const createJsonForIlogic = (scene: any) => {
  const parts = [];
  for (let i = 0; i < scene.children.length; i++) {
    if (
      scene.children[i].name.includes('3d') &&
      !scene.children[i].name.includes('Dimension') &&
      !scene.children[i].name.includes('Border') &&
      !scene.children[i].name.includes('UpdateText3d') &&
      !scene.children[i].name.includes('Arrow3d') &&
      !scene.children[i].name.includes('OpeningWidthText3d') &&
      !scene.children[i].name.includes('Seal3d') &&
      !scene.children[i].name.includes('Brush3d') &&
      !scene.children[i].name.includes('Ceiling')
    ) {
      if (scene.children[i].factoryFileName === 'WoodyElementProfile') {
        if (scene.children[i].swapDimensionsInExport) {
          scene.children[i].fxParameters.length =
            scene.children[i].fxParameters.height;
        }

        scene.children[i].fxParameters.height = undefined;
        scene.children[i].fxParameters.width = undefined;
      }

      parts.push({
        name: scene.children[i].name.split(' ')[0],
        wallID: scene.children[i].name.split(' ')[1],
        fxParameters: scene.children[i].fxParameters,
        matrix: scene.children[i].matrix.elements,
        factoryFileName: scene.children[i].factoryFileName,
      });
    }

    if (
      scene.children[i].name.includes('WallLine') &&
      scene.children[i].properties.wallType.toLowerCase().includes('glass wall')
    ) {
      const hasGlassWallPlaced =
        window.MasterAssemblyFunctions.GetIfWallIsPlaced(
          scene,
          scene.children[i].name.split(' ')[1]
        );

      if (hasGlassWallPlaced) {
        /* 
                        NOTICE!
                        This needs to be copied and parts property needs to be set
                        to undefined and not deleted as it is in Cadcraft's version.
                        Othwerwise this function will also remove parts data from anywhere it is used.
                        */
        const allFxParameters = {
          ...scene.children[i].properties,
        };

        if (allFxParameters.parts) {
          allFxParameters.parts = undefined;
        }

        if (allFxParameters.endCrossData) {
          allFxParameters.endCrossData = undefined;
        }

        if (allFxParameters.startCrossData) {
          allFxParameters.startCrossData = undefined;
        }

        if (allFxParameters.doorGlassIds) {
          allFxParameters.doorGlassIds = undefined;
        }

        if (allFxParameters.doorGlassNames) {
          allFxParameters.doorGlassNames = undefined;
        }

        let roofOffset = 0;
        let woodyRoofProfileOffset = 0;
        if (
          scene.children[i].properties.glazingWallType.includes('woody') &&
          !scene.children[i].properties.glazingWallType.includes('woodyalu') &&
          !scene.children[i].properties.glazingWallType.includes('woody2kalu')
        ) {
          roofOffset = scene.children[i].properties.woodyRoofProfileOffset;
        } else {
          roofOffset = scene.children[i].properties.roofProfileOffset;
          woodyRoofProfileOffset =
            scene.children[i].properties.woodyRoofProfileOffset;
        }

        const {
          endAngle,
          leftWallOffset,
          positionOffset,
          rightWallOffset,
          startAngle,
        } = scene.children[i].properties;

        parts.push({
          name: scene.children[i].name.split(' ')[0],
          wallID: scene.children[i].name.split(' ')[1],
          matrix: scene.children[i].matrix.elements,
          fxParameters: {
            endAngle,
            leftWallOffset,
            positionOffset: -positionOffset,
            rightWallOffset,
            roofOffset,
            woodyRoofProfileOffset,
            startAngle,
            wallData: JSON.stringify(allFxParameters),
          },
        });
      }
    }

    if (scene.children[i].name.includes('workPoint')) {
      parts.push({
        name: scene.children[i].name,
        wallID: scene.children[i].name.split(' ')[1],
        matrix: scene.children[i].matrix.elements,
      });
    }
  }

  console.log(JSON.stringify(parts));
  return parts;
};

export default createJsonForIlogic;
